/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ControlcenterMelcoModelsCreateThreadChart,
    ControlcenterMelcoModelsCreateThreadChartFromJSON,
    ControlcenterMelcoModelsCreateThreadChartToJSON,
    ControlcenterMelcoModelsError,
    ControlcenterMelcoModelsErrorFromJSON,
    ControlcenterMelcoModelsErrorToJSON,
    ControlcenterMelcoModelsGenericList1MelcoModelsThreadChartListItem,
    ControlcenterMelcoModelsGenericList1MelcoModelsThreadChartListItemFromJSON,
    ControlcenterMelcoModelsGenericList1MelcoModelsThreadChartListItemToJSON,
    ControlcenterMelcoModelsThreadChart,
    ControlcenterMelcoModelsThreadChartFromJSON,
    ControlcenterMelcoModelsThreadChartToJSON,
} from '../models';

export interface ManageThreadsApiThreadsCreateDraftRequest {
    controlcenterMelcoModelsCreateThreadChart?: ControlcenterMelcoModelsCreateThreadChart;
}

export interface ManageThreadsApiThreadsDeleteRequest {
    id: string;
}

export interface ManageThreadsApiThreadsDownloadThreadRequest {
    id: string;
}

export interface ManageThreadsApiThreadsDuplicateDraftRequest {
    id: string;
}

export interface ManageThreadsApiThreadsGetByIdRequest {
    id: string;
    publishState?: string;
}

export interface ManageThreadsApiThreadsPublishRequest {
    id: string;
}

export interface ManageThreadsApiThreadsRevertRequest {
    id: string;
}

export interface ManageThreadsApiThreadsSearchRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    publishState?: string;
    searchText?: string;
    version?: string;
    productList?: string;
}

export interface ManageThreadsApiThreadsUpdateRequest {
    id: string;
    controlcenterMelcoModelsCreateThreadChart?: ControlcenterMelcoModelsCreateThreadChart;
}

export interface ManageThreadsApiThreadsUploadRequest {
    id: string;
    file?: Blob;
}

/**
 * 
 */
export class ManageThreadsApi extends runtime.BaseAPI {

    /**
     */
    async threadsCreateDraftRaw(requestParameters: ManageThreadsApiThreadsCreateDraftRequest): Promise<runtime.ApiResponse<ControlcenterMelcoModelsThreadChart>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/manage/threads/draft`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ControlcenterMelcoModelsCreateThreadChartToJSON(requestParameters.controlcenterMelcoModelsCreateThreadChart),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoModelsThreadChartFromJSON(jsonValue));
    }

    /**
     */
    async threadsCreateDraft(requestParameters: ManageThreadsApiThreadsCreateDraftRequest): Promise<ControlcenterMelcoModelsThreadChart> {
        const response = await this.threadsCreateDraftRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async threadsDeleteRaw(requestParameters: ManageThreadsApiThreadsDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling threadsDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/threads/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async threadsDelete(requestParameters: ManageThreadsApiThreadsDeleteRequest): Promise<void> {
        await this.threadsDeleteRaw(requestParameters);
    }

    /**
     */
    async threadsDownloadThreadRaw(requestParameters: ManageThreadsApiThreadsDownloadThreadRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling threadsDownloadThread.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/threads/{Id}/download`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async threadsDownloadThread(requestParameters: ManageThreadsApiThreadsDownloadThreadRequest): Promise<Blob> {
        const response = await this.threadsDownloadThreadRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async threadsDuplicateDraftRaw(requestParameters: ManageThreadsApiThreadsDuplicateDraftRequest): Promise<runtime.ApiResponse<ControlcenterMelcoModelsThreadChart>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling threadsDuplicateDraft.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/threads/{Id}/duplicate/draft`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoModelsThreadChartFromJSON(jsonValue));
    }

    /**
     */
    async threadsDuplicateDraft(requestParameters: ManageThreadsApiThreadsDuplicateDraftRequest): Promise<ControlcenterMelcoModelsThreadChart> {
        const response = await this.threadsDuplicateDraftRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async threadsGetByIdRaw(requestParameters: ManageThreadsApiThreadsGetByIdRequest): Promise<runtime.ApiResponse<ControlcenterMelcoModelsThreadChart>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling threadsGetById.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/threads/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoModelsThreadChartFromJSON(jsonValue));
    }

    /**
     */
    async threadsGetById(requestParameters: ManageThreadsApiThreadsGetByIdRequest): Promise<ControlcenterMelcoModelsThreadChart> {
        const response = await this.threadsGetByIdRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async threadsPublishRaw(requestParameters: ManageThreadsApiThreadsPublishRequest): Promise<runtime.ApiResponse<ControlcenterMelcoModelsThreadChart>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling threadsPublish.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/threads/{Id}/publish`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoModelsThreadChartFromJSON(jsonValue));
    }

    /**
     */
    async threadsPublish(requestParameters: ManageThreadsApiThreadsPublishRequest): Promise<ControlcenterMelcoModelsThreadChart> {
        const response = await this.threadsPublishRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async threadsRevertRaw(requestParameters: ManageThreadsApiThreadsRevertRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling threadsRevert.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/threads/{Id}/revert`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async threadsRevert(requestParameters: ManageThreadsApiThreadsRevertRequest): Promise<void> {
        await this.threadsRevertRaw(requestParameters);
    }

    /**
     */
    async threadsSearchRaw(requestParameters: ManageThreadsApiThreadsSearchRequest): Promise<runtime.ApiResponse<ControlcenterMelcoModelsGenericList1MelcoModelsThreadChartListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.version !== undefined) {
            queryParameters['version'] = requestParameters.version;
        }

        if (requestParameters.productList !== undefined) {
            queryParameters['product_list'] = requestParameters.productList;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/threads`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoModelsGenericList1MelcoModelsThreadChartListItemFromJSON(jsonValue));
    }

    /**
     */
    async threadsSearch(requestParameters: ManageThreadsApiThreadsSearchRequest): Promise<ControlcenterMelcoModelsGenericList1MelcoModelsThreadChartListItem> {
        const response = await this.threadsSearchRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async threadsUpdateRaw(requestParameters: ManageThreadsApiThreadsUpdateRequest): Promise<runtime.ApiResponse<ControlcenterMelcoModelsThreadChart>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling threadsUpdate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/manage/threads/{Id}/draft`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ControlcenterMelcoModelsCreateThreadChartToJSON(requestParameters.controlcenterMelcoModelsCreateThreadChart),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoModelsThreadChartFromJSON(jsonValue));
    }

    /**
     */
    async threadsUpdate(requestParameters: ManageThreadsApiThreadsUpdateRequest): Promise<ControlcenterMelcoModelsThreadChart> {
        const response = await this.threadsUpdateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async threadsUploadRaw(requestParameters: ManageThreadsApiThreadsUploadRequest): Promise<runtime.ApiResponse<ControlcenterMelcoModelsThreadChart>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling threadsUpload.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/manage/threads/{Id}/draft/upload`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoModelsThreadChartFromJSON(jsonValue));
    }

    /**
     */
    async threadsUpload(requestParameters: ManageThreadsApiThreadsUploadRequest): Promise<ControlcenterMelcoModelsThreadChart> {
        const response = await this.threadsUploadRaw(requestParameters);
        return await response.value();
    }

}
